import './CashinButton.less';

import React, { FC } from 'react';
import { LoggedInOnly } from '../../utils';
import { useCashinOfferSubscription } from './CashinOffersList';
import CashinButtonContent from './CashinButtonContent';

export const CashinButton: FC<{
    large?: boolean;
    ticketId: string;
    handleClick: any;
    handleClickAutoCashin: any;
}> = ({ large, ticketId, handleClick, handleClickAutoCashin }) => {
    return (
        <LoggedInOnly>
            <CashinWrapper
                large={large}
                ticketId={ticketId}
                handleClick={handleClick}
                handleClickAutoCashin={handleClickAutoCashin}
            />
        </LoggedInOnly>
    );
};

const CashinWrapper: FC<{
    large: boolean;
    ticketId: string;
    handleClick: any;
    handleClickAutoCashin: any;
}> = ({ large, ticketId, handleClick, handleClickAutoCashin }) => {
    useCashinOfferSubscription();
    return (
        <CashinButtonContent
            large={large}
            ticketId={ticketId}
            handleClick={handleClick}
            handleClickAutoCashin={handleClickAutoCashin}
        />
    );
};
